const url = "https://247accessibledocuments.com/";

const contact_us = `${url}contact-us/`;
const help = `${url}resources/`;
const term_and_conditions = `${url}terms-of-service/`;

export { contact_us, help, term_and_conditions };
